import React, {
  ReactElement,
} from 'react';
import {Paper, Stack, Table, TableContainer, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import {CancelRounded, CheckCircleRounded} from "@mui/icons-material";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {MoreOptions} from "../../../components/Table/assets/MoreOptions";
import {activityPrice} from "../../../schema/activityPrice";
import {NumericFormat} from "react-number-format";
import {formatNumber} from "../../../reducer/actions/formatNumber";

export const PricesTable= ({
                       rows
                            }: {
  rows: any;
}): ReactElement => {

  console.log(rows);

  return (
    <>
      <Stack
        direction={'column'}
        gap={1}
        alignContent={'center'}
        sx={{
          width: '100%',
          marginY: '2px',
          background: '#fff',
          boxShadow: '0px 2px 5px -1px #00000017',
          borderRadius: '10px',
          padding: '15px'
        }}
      >
        <Box>
          <Typography
            variant="subtitle1"
            fontWeight={'bold'}
          >
            Prices
          </Typography>
        </Box>
        <Stack
          sx={{
            width: '100%',
            '& svg': {
              height: '30px',
              width: '30px',
              display: 'inline-block'
            }
          }}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <TableContainer component={Paper}>
            <Table
              aria-label="simple table"
              size="small"
              sx={{
                '& .MuiTableBody-root .MuiTableRow-root': {
                  background: '#fff',
                },
              }}
            >
              <TableHead
                sx={{
                  '& .MuiTableCell-root': {
                    color: 'inherit',
                    border: 'none',
                  },
                  '& .MuiTableRow-root .MuiTableCell-root.MuiTableCell-head': {
                    border: 'none',
                    fontSize: '14px',
                    p: '10px',
                  },
                  background: '#256861',
                  color: '#fff',
                }}
              >
                <TableRow>
                  {Array.from({ length: 50 }).map((_, cellIndex) => (
                    <TableCell
                      sx={{
                        minWidth: `75px`,
                      }}
                    >{cellIndex+1}</TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {(rows||[]).map((row: any, index: number) => {
                  return (
                    <TableRow
                      key={index}>
                      {Array.from({ length: 50 }).map((_, cellIndex) => (
                        <TableCell
                          sx={{
                            outline: '1px solid #e7e7e7'
                          }}
                          key={cellIndex}
                        >
                          <NumericFormat
                            disabled={true}
                            className={'w-full text-center'}
                            value={row[`size_${cellIndex+1}`]}
                            thousandSeparator=" "
                            decimalScale={2}
                            fixedDecimalScale={true}
                            onChange={(event) => {
                            }}
                            onPaste={(event: any) =>{

                            }}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      </Stack>
    </>
  );
};
